export default __webpack_public_path__ + "static/media/closet2-480w.f5433b22.webp";